import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { ArrowLeft, Trophy, Crown } from "lucide-react";

const TIER_COLORS = { bronze: "#CD7F32", silver: "#C7CAD1", gold: "#FFD700", platinum: "#7DF9FF" };

export default function Leaderboard() {
  const navigate = useNavigate();
  const [period, setPeriod] = useState("all");
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/leaderboard?period=${period}`).then(({ data }) => setData(data)).catch(() => {}); }, [period]);

  const top = data?.top || [];
  const podium = top.slice(0, 3);
  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white" data-testid="leaderboard-page">
      <div className="max-w-2xl mx-auto px-4 py-6">
        <button onClick={() => navigate("/esplora")} className="flex items-center gap-2 text-zinc-400 hover:text-white mb-4 text-sm" data-testid="leaderboard-back"><ArrowLeft className="h-4 w-4" /> Mappa</button>
        <div className="flex items-center gap-3 mb-6"><div className="h-12 w-12 rounded-2xl bg-[#FFD700]/15 border border-[#FFD700]/40 flex items-center justify-center"><Trophy className="h-6 w-6 text-[#FFD700]" /></div><div><h1 className="text-2xl font-display font-bold">Classifica</h1><p className="text-sm text-zinc-400">I clienti più attivi del territorio.</p></div></div>

        <div className="inline-flex rounded-full bg-[#1C1C1F] border border-white/10 p-1 mb-6">
          <button data-testid="lb-all" onClick={() => setPeriod("all")} className={`px-4 py-1.5 rounded-full text-sm ${period === "all" ? "bg-[#00E676] text-black font-semibold" : "text-zinc-400"}`}>Sempre</button>
          <button data-testid="lb-month" onClick={() => setPeriod("month")} className={`px-4 py-1.5 rounded-full text-sm ${period === "month" ? "bg-[#00E676] text-black font-semibold" : "text-zinc-400"}`}>Questo mese</button>
        </div>

        {podium.length > 0 && (
          <div className="flex items-end justify-center gap-3 mb-6">
            {[podium[1], podium[0], podium[2]].filter(Boolean).map((p) => {
              const isFirst = p.rank === 1; const col = TIER_COLORS[p.level] || "#00E676";
              return (
                <div key={p.rank} data-testid={`podium-${p.rank}`} className="flex flex-col items-center" style={{ width: 96 }}>
                  {isFirst && <Crown className="h-5 w-5 text-[#FFD700] mb-1" />}
                  <div className="rounded-2xl w-full flex flex-col items-center justify-end p-3 border" style={{ height: isFirst ? 130 : 100, background: `${col}18`, borderColor: `${col}55` }}>
                    <div className="font-display font-black text-2xl" style={{ color: col }}>{p.rank}</div>
                    <div className="text-xs font-medium truncate w-full text-center">{p.name}</div>
                    <div className="text-[10px] text-zinc-400">{p.xp} XP</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="space-y-2">
          {top.map((p) => (
            <div key={p.rank} data-testid={`lb-row-${p.rank}`} className={`flex items-center justify-between rounded-lg p-3 border ${p.is_me ? "bg-[#00E676]/10 border-[#00E676]/40" : "bg-[#1C1C1F] border-white/10"}`}>
              <div className="flex items-center gap-3"><span className={`font-display font-black w-7 ${p.rank <= 3 ? "text-[#FFD700]" : "text-zinc-600"}`}>{p.rank}</span><span className="font-medium">{p.name}{p.is_me && <span className="text-[#00E676] text-xs ml-1">(tu)</span>}</span></div>
              <span className="text-sm text-zinc-400">{p.xp} XP</span>
            </div>
          ))}
          {top.length === 0 && <div className="text-zinc-500 py-10 text-center">Ancora nessun punteggio. Completa missioni per entrare in classifica!</div>}
        </div>

        {data?.me && !top.some((t) => t.is_me) && (
          <div data-testid="lb-me" className="mt-4 flex items-center justify-between rounded-lg p-3 border bg-[#00E676]/10 border-[#00E676]/40">
            <div className="flex items-center gap-3"><span className="font-display font-black w-7 text-[#00E676]">{data.me.rank}</span><span className="font-medium">{data.me.name} <span className="text-[#00E676] text-xs">(tu)</span></span></div>
            <span className="text-sm text-zinc-400">{data.me.xp} XP</span>
          </div>
        )}
      </div>
    </div>
  );
}
